import { useState, useEffect } from 'react';
import { useModal } from './useModal';

export const useLoginRegisterModals = (lockBody = false) => {
  const { isOpen: isLoginModalOpen, toggle: handleToggleLoginModal } = useModal(false, { lockBody });
  const { isOpen: isRegisterModalOpen, toggle: handleToggleRegisterModal } = useModal(false, { lockBody });

  // overflow制御
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const anyOpen = isLoginModalOpen || isRegisterModalOpen;

    if (anyOpen) {
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    } else {
      html.style.overflow = '';
      body.style.overflow = '';
    }
  }, [isLoginModalOpen, isRegisterModalOpen]);

  // モーダル切替
  const handleChangeModal = (from: 'login' | 'register') => {
    if (from === 'login') {
      handleToggleLoginModal();
      handleToggleRegisterModal();
    } else {
      handleToggleRegisterModal();
      handleToggleLoginModal();
    }
  };

  // redirectUrl管理
  const [redirectUrl, setRedirectUrl] = useState('');
  useEffect(() => {
    setRedirectUrl(window.location.href);
  }, []);

  // path判定
  const isRecruitmentOrEventOrTvOrCompanyPath = (): boolean => {
    const path = window.location.pathname;
    return (
      /^\/events\/\d+/.test(path) ||
      /^\/recruitments\/\d+/.test(path) ||
      /^\/tvs\/\d+/.test(path) ||
      /^\/companies(\/\d+)?/.test(path)
    );
  };

  return {
    // 状態
    isLoginModalOpen,
    isRegisterModalOpen,
    redirectUrl,
    isRecruitmentOrEventOrTvOrCompanyPath,

    // アクション
    handleToggleLoginModal,
    handleToggleRegisterModal,
    handleChangeModal,
  };
};
